import React from 'react';

import { arrowRightIcon } from '../../img/icons';

const FilterTitle = ({ classes = '', title, onClick = () => {} }) => (
  <button
    className={ `flex w-full justify-between py-20 ${classes}` }
    type='button'
    onClick={ onClick }
  >
    <p className='font-500 my-0 mx-0 text-left'><strong>{ title }</strong></p>
    <span className='filters__arrow m-5'>{ arrowRightIcon }</span>
  </button>
);

export default FilterTitle;
